import React from "react";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";
import "./input.scss";

function Input({
  className,
  name,
  required,
  readOnly, // Nueva prop
  id,
  label,
  labelClass,
  type,
  children,
  value,
  setValue,
  infoText, // Nueva prop para información adicional
}) {
  id = id || uuid();

  const labelLength = label.length;
  labelClass = labelClass ? `label-${labelClass}` : "";

  if (!labelClass) {
    switch (true) {
      case labelLength < 40:
        labelClass = "label-small";
        break;
      case labelLength >= 40 && labelLength < 80:
        labelClass = "label-medium";
        break;
      case labelLength >= 80:
        labelClass = "label-long";
        break;
      default:
        break;
    }
  }
  /*const formatCurrency = (value) => {
    const numericValue = value.replace(/\D/g, ""); // Solo permite números enteros
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0, // Asegura que no haya decimales
      maximumFractionDigits: 0, // Asegura que no haya decimales
    }).format(numericValue);
  };*/

  const formatCurrency = (value) => {
  const numericValue = value.replace(/\D/g, "");
  return new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numericValue);
};


  const handleCurrencyChange = (e) => {
    e.preventDefault();
    const formattedValue = formatCurrency(e.target.value);
    setValue(e.target.name, formattedValue);
  };
  function InputByType(type) {
    switch (type) {
      case "textarea":
        return <textarea name={name} id={id} required={required}/>;
      case "select":
        return (
          <select
            required={required}
            name={name}
            id={id}
            onChange={(e) => {
              e.preventDefault();
              setValue(e.target.name, e.target.value);
            }}
          >
            {children}
          </select>
        );
      case "currency":
        return (
          <input
            required={required}
            name={name}
            id={id}
            type="text" // Cambia a `text` para permitir formato de moneda
            value={value}
            readOnly={readOnly}
            onChange={handleCurrencyChange}
            placeholder="$0.00"
            style={{ textAlign: "left", padding: "5px", borderRadius: "5px", border: "1px solid #ccc" }}
          />
        );
      case "datetime-local": 
        return (
          <input
            required={required}
            name={name}
            id={id}
            type="datetime-local"
            value={value}
            readOnly={readOnly}
            min="1900-01-01T00:00" 
            max="2100-12-31T23:59" 
            onChange={(e) => {
              e.preventDefault();
              setValue(e.target.name, e.target.value);
            }}
          />
        );
      default:
        return (
          <input
            required={required}
            name={name}
            id={id}
            type={type}
            value={value}
            readOnly={readOnly} // Propiedad agregada aquí
            onChange={(e) => {
              e.preventDefault();
              setValue(e.target.name, e.target.value);
            }}
          />
        );
    }
  }

  return (
    <div className={`input ${className || ""}`}>
      <div className={`container-label ${labelClass}`}>
        
        <label htmlFor={id}>
          {label}{required ? "*" : ""}
          {infoText && (
            <span className="info-icon">
              ℹ️
              <span className="tooltip-text">{infoText}</span>
            </span>
          )}
        </label>
      </div>
      <div className="container-input">{InputByType(type)}</div>
    </div>
  );
}

Input.defaultProps = {
  required: false,
  readOnly: false, // Valor por defecto
};

Input.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  readOnly: PropTypes.bool, // Nueva prop validada
  labelClass: PropTypes.oneOf(["small", "medium", "long"]),
  type: PropTypes.oneOf([
    "button",
    "checkbox",
    "color",
    "date",
    "datetime-local",
    "email",
    "file",
    "hidden",
    "image",
    "month",
    "number",
    "currency", // Nuevo tipo para manejar moneda
    "password",
    "radio",
    "range",
    "reset",
    "search",
    "submit",
    "tel",
    "text",
    "time",
    "url",
    "week",
    "textarea",
    "select",
  ]),
  value: PropTypes.any,
  setValue: PropTypes.func.isRequired,
  infoText: PropTypes.string, // Nueva prop validada
};

export default Input;
